import {useQuery} from "@tanstack/react-query";
import {getAccessToken} from "../../api/requests/token";

/**
 * @typedef {{country: string, access_token: string, expires_in: number, account_id?:string}} Token
 */

export const useToken = () =>
  useQuery({
    queryKey: ["use-token"],
    queryFn: getAccessToken,
  });

export const useIsAuthenticated = () => {
  const {data: token} = useToken();

  return Boolean(token?.account_id);
};

export const useValidationHints = () => {
  const {data: token} = useToken();

  return token ? token.validation_hints : [];
};

export const useIsEmailVerified = () => {
  const validationHints = useValidationHints();

  return !validationHints.includes("validate-email-address");
};

export const useIsUsernameVerified = () => {
  const validationHints = useValidationHints();

  return !validationHints.includes("set-username");
};
